"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asciiExtendedOnly = asciiExtendedOnly;
exports.asciiOnly = asciiOnly;
exports.asciiOnlyEmail = asciiOnlyEmail;
exports.excludeNumbers = excludeNumbers;
exports.excludeSymbolsTitle = exports.excludeSymbolsNamesDataStandards = exports.excludeSymbolsNames = void 0;
exports.lettersOnly = lettersOnly;
exports.numbersOnly = numbersOnly;
exports.numbersPositiveOnly = numbersPositiveOnly;
exports.numbersSlashOnly = numbersSlashOnly;
exports.numbersSpacesDashesBracketsOnly = numbersSpacesDashesBracketsOnly;
exports.numbersSpacesDashesBracketsPlusOnly = numbersSpacesDashesBracketsPlusOnly;
exports.numbersSpacesOnly = numbersSpacesOnly;
exports.uppercaseLettersNumbers = uppercaseLettersNumbers;
exports.uppercaseLettersNumbersSpaces = uppercaseLettersNumbersSpaces;
exports.uppercaseLettersNumbersSpacesDash = uppercaseLettersNumbersSpacesDash;
var _isString = _interopRequireDefault(require("lodash/isString"));
var _regex = require("../regex");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function asciiOnly() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!(0, _isString["default"])(value)) {
    return '';
  }
  var regex = new RegExp("[^".concat(_regex.asciiPattern, "]"), 'g');
  return value.replace(regex, '');
}
function asciiOnlyEmail() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var prev = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var lengthDiff = value.length - prev.length;

  // ignore chrome @input to punycode conversions eg: '@£' -> '@xn--9a'
  if (lengthDiff > 4 && prev.indexOf('xn--') === -1 && value.indexOf('xn--') !== -1) {
    return prev;
  }
  var val = value.replace(_regex.emailInvalidCharsRegex, '');
  if (val.indexOf('..') !== -1) {
    val = val.replace(/(\.+)/g, '.');
  }
  if (val.indexOf('@.') !== -1) {
    val = val.replace(/(@\.)/g, '@');
  }
  if (val.indexOf('.') === 0) {
    val = val.replace(/\./, '');
  }
  if (val.indexOf('@') === 0) {
    val = val.replace(/(@+)/, '');
  }
  var atMatches = val.match(/@/g);
  if (atMatches && atMatches.length > 1) {
    // strip all but first @
    var index = val.indexOf('@');
    var prefix = val.substring(0, index + 1);
    var suffix = val.substr(index).replace(/@/g, '');
    val = "".concat(prefix).concat(suffix);
  }
  return asciiOnly(val.trim());
}
function asciiExtendedOnly() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!(0, _isString["default"])(value)) {
    return '';
  }
  var regex = new RegExp("[^".concat(_regex.asciiExtendedPattern, "]"), 'g');
  return value.replace(regex, '');
}
function lettersOnly() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!(0, _isString["default"])(value)) {
    return '';
  }
  var regex = new RegExp("[^".concat(_regex.lettersPattern, "]+"), 'g');
  return value.replace(regex, '');
}
function numbersOnly() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!(0, _isString["default"])(value)) {
    return '';
  }
  var regex = new RegExp("[^".concat(_regex.numbersPattern, "]+"), 'g');
  return value.replace(regex, '');
}
function numbersPositiveOnly() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!(0, _isString["default"])(value)) {
    return '';
  }
  var regex = /^0+/g;
  return value.replace(regex, '');
}
function numbersSlashOnly() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!(0, _isString["default"])(value)) {
    return '';
  }
  var regex = new RegExp("[^".concat(_regex.numbersSlashPattern, "]+"), 'g');
  return value.replace(regex, '');
}
function numbersSpacesOnly() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!(0, _isString["default"])(value)) {
    return '';
  }
  var regex = new RegExp("[^".concat(_regex.numbersSpacesPattern, "]+"), 'g');
  return value.replace(regex, '');
}
function numbersSpacesDashesBracketsOnly() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!(0, _isString["default"])(value)) {
    return '';
  }
  var regex = new RegExp("[^".concat(_regex.numbersSpacesDashesBracketsPattern, "]+"), 'g');
  return value.replace(regex, '');
}
function numbersSpacesDashesBracketsPlusOnly() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!(0, _isString["default"])(value)) {
    return '';
  }
  var regex = new RegExp("[^".concat(_regex.numbersSpacesDashesBracketsPlusPattern, "]+"), 'g');
  return value.replace(regex, '');
}
function excludeNumbers() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!(0, _isString["default"])(value)) {
    return '';
  }
  var regex = new RegExp("[".concat(_regex.numbersPattern, "]"), 'g');
  return value.replace(regex, '');
}
var excludeSymbolsTitle = exports.excludeSymbolsTitle = function excludeSymbolsTitle() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!(0, _isString["default"])(value)) {
    return '';
  }
  var regex = new RegExp("[^".concat(_regex.lettersDotPattern, "]+"), 'g');
  return value.replace(regex, '');
};
var excludeSymbolsNames = exports.excludeSymbolsNames = function excludeSymbolsNames() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!(0, _isString["default"])(value)) {
    return '';
  }
  var regex = new RegExp("[^".concat(_regex.lettersDotDashApostropheSpacePattern, "]+"), 'g');
  return value.replace(regex, '');
};
var excludeSymbolsNamesDataStandards = exports.excludeSymbolsNamesDataStandards = function excludeSymbolsNamesDataStandards() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!(0, _isString["default"])(value)) {
    return '';
  }
  var regex = new RegExp("[^".concat(_regex.lettersDashApostropheSpacePattern, "]+"), 'g');
  return value.replace(regex, '').replace(/^[\s'-]+/g, '').replace(/([\s'-])+/g, '$1');
};
function uppercaseLettersNumbers() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!(0, _isString["default"])(value)) {
    return '';
  }
  var regex = new RegExp("[^".concat(_regex.lettersNumbersPattern, "]+"), 'g');
  return value.replace(regex, '').toUpperCase();
}
function uppercaseLettersNumbersSpaces() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!(0, _isString["default"])(value)) {
    return '';
  }
  var regex = new RegExp("[^".concat(_regex.lettersNumbersSpacesPattern, "]+"), 'g');
  return value.replace(regex, '').toUpperCase();
}
function uppercaseLettersNumbersSpacesDash() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!(0, _isString["default"])(value)) {
    return '';
  }
  var regex = new RegExp("[^".concat(_regex.lettersNumbersSpacesDashPattern, "]+"), 'g');
  return value.replace(regex, '').toUpperCase();
}